import { PublicKey, VersionedTransactionResponse } from "@solana/web3.js";
import { UNLINK_PROGRAM_ID } from "../../constants/general";

export function txIncludesUnlinkProgram(
  tx: VersionedTransactionResponse,
  unlinkProgramId: PublicKey = UNLINK_PROGRAM_ID
): boolean {
  try {
    const message = tx.transaction.message;

    let accountKeys: PublicKey[];
    let instructions: { programIdIndex: number }[];

    if (message.version === "legacy" || message.version === undefined) {
      accountKeys = message.accountKeys;
      instructions = message.instructions;
    } else {
      accountKeys = message.staticAccountKeys;
      instructions = message.compiledInstructions;
    }

    const programIndexes = instructions.map((ix) => ix.programIdIndex);
    return programIndexes.some((ix) => accountKeys[ix]?.equals(unlinkProgramId));
  } catch (err) {
    console.warn("[includesUnlinkProgram] Failed to parse transaction", err);
    return false;
  }
}